import { render, staticRenderFns } from "./activeData.vue?vue&type=template&id=7fc72c02&"
import script from "./activeData.vue?vue&type=script&lang=js&"
export * from "./activeData.vue?vue&type=script&lang=js&"
import style0 from "./activeData.vue?vue&type=style&index=0&id=7fc72c02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports